import {put, takeEvery, call} from 'redux-saga/effects';
import {
    UNLOCK_PERIOD_ACTION_REQUEST,
    UNLOCK_PERIOD_ACTION_SUCCESS,
    UNLOCK_PERIOD_ACTION_FAILURE,
    UNLOCK_PERIOD_ACTION
} from '../constants';

import Api, {ApiMethods} from 'feedback-system/middleware/api';

import {
    UnlockPeriodRequest,
    UnlockPeriodSuccess,
    UnlockPeriodFailure,
    UnlockPeriodAction
} from '../typedef';

type IActions = UnlockPeriodRequest & UnlockPeriodSuccess & UnlockPeriodFailure & UnlockPeriodAction;

function* unlockPeriod(action: IActions) {
    try {

        yield put({type: UNLOCK_PERIOD_ACTION_REQUEST});

        const dataPeriod = yield call(Api.fetch, {
            endpoint: `periods/lock?id=${action.id}&lockedStatus=false`,
            method: ApiMethods.PUT
        });

        yield put({
            type: UNLOCK_PERIOD_ACTION_SUCCESS,
            period: dataPeriod.responseData
        });
    } catch (e) {
        yield put({type: UNLOCK_PERIOD_ACTION_FAILURE, error: e});
    }
}

function* unlockPeriodSaga() {
    yield takeEvery(UNLOCK_PERIOD_ACTION, unlockPeriod);
}

export {
    unlockPeriodSaga
};
